import { render, staticRenderFns } from "./popup-reset.vue?vue&type=template&id=7803e1a0&scoped=true&"
import script from "./popup-reset.vue?vue&type=script&lang=js&"
export * from "./popup-reset.vue?vue&type=script&lang=js&"
import style0 from "./popup-reset.vue?vue&type=style&index=0&id=7803e1a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803e1a0",
  null
  
)

export default component.exports